// components
import { CurrencySymbol, Slider, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';

// utils
import { buildTestId } from '@/utils/helpers.utils';

// types
import type PriceFilterStore from '@tajawal/web-flights-sdk/lib/stores/filter/price-filter.store';

// hooks
import usePriceFilter from '@/hooks/usePriceFilter';

export type PriceFilterProps = {
  testIdPrefix: string;
  filter: PriceFilterStore;
};

function PriceFilter({ testIdPrefix, filter }: PriceFilterProps): JSX.Element {
  const testId = buildTestId(testIdPrefix, 'Price');

  const { minValue, maxValue, currency, currentValue, handleChange, handleChangeCommit, formatPriceWithDecimals } =
    usePriceFilter(filter);

  return (
    <div style={{ paddingInlineEnd: 12 }} data-testId={testId}>
      <Slider
        // @ts-ignore we can send an element, and we should until the design team fix the arabic currency flip
        labelFactory={(value) => (
          <CurrencySymbol variant={TYPOGRAPHY_VARIANT.BODY2} currency={currency}>
            {' '}
            {formatPriceWithDecimals(+value, 0)}{' '}
          </CurrencySymbol>
        )}
        testId={buildTestId(testId, 'Slider')}
        onChangeCommitted={handleChangeCommit}
        currency={currency}
        minAmount={minValue}
        maxAmount={maxValue}
        value={currentValue[1]}
        // @ts-ignore what they exposed was an e of type any, but the actual type is _event: Event, newValue: number | number[]
        onChange={handleChange}
      />
    </div>
  );
}

export default PriceFilter;
